export const SMART_APP_BANNER_SHOW = 'smart_app_banner_show';
export const SMART_APP_BANNER_CLICK = 'smart_app_banner_click';
export const SMART_APP_BANNER_CLOSE = 'smart_app_banner_close';
